var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.6667,
    rx: 8,
    fill: "url(#paint0_linear_9029_50841)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9029_50841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6129 15.0323L12.3629 10.1549C11.6926 9.75882 10.666 10.1432 10.666 11.1229V20.8752C10.666 21.7541 11.6199 22.2838 12.3629 21.8432L20.6129 16.9682C21.3488 16.5346 21.3512 15.4658 20.6129 15.0323Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9029_50841",
    x1: 16,
    y1: 30.6667,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD2A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD2A3F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9029_50841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 12,
    fill: "white",
    transform: "translate(10.666 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.3fd543844454bbb5bebe51503c505edc.svg";
export { ForwardRef as ReactComponent };